import { render, staticRenderFns } from "./ProfileTable.vue?vue&type=template&id=28923634&scoped=true&"
import script from "./ProfileTable.vue?vue&type=script&lang=ts&"
export * from "./ProfileTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTable.vue?vue&type=style&index=0&id=28923634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28923634",
  null
  
)

export default component.exports